<template>
  <div>
    <v-card class="grid_line_first" elevation="0">
      <div class="grid_warehouse">
        <v-card elevation="6" class="mr-md-2 mr-lg-2 mr-xl-2">
          <div class="pa-3">
            <div class="grid_warehouse_header">
              <div class="mx-auto">
                <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_value_stock" :src="img_value_stock"/>
              </div>
              <div class="text-center" style="font-size: 28px"><b>มูลค่าสินค้าในคลัง</b></div>
            </div>
            <div class="text-center mt-2 font_warehouse"><b>{{ format_number(total_item_value) }}</b></div>
            <div class="text-center" style="font-size: 24px !important"><b>บาท</b></div>
          </div>
        </v-card>
        <v-card elevation="6" class="ml-md-2 ml-lg-2 ml-xl-2">
          <div class="pa-3">
            <div class="grid_select">
              <div class="grid_header_sell">
                <div class="mx-auto">
                  <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_value" :src="img_value"/>
                </div>
                <div class="pt-3 pl-2" style="font-size: 26px"><b>มูลค่าสินค้าทิ้งต่อเดือน</b></div>
              </div>
              <div class="ma-2">
                <v-select color="#86bc3a" @input="dump_data_select()" :items="year_arr" item-text="show_year" item-value="year_eng" v-model="selected_year_value" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
              </div>
            </div>
            <div style="height: 30vh !important">
              <canvas id="myChartValue"></canvas>
            </div>
          </div>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import img_value_stock from "@/assets/dollar.png";
import img_value from "@/assets/low_report.png";
import Chart from "chart.js/auto";
import {formatNumber} from "@/js/handler";
import {HTTP} from "@/axios";

export default {
  name: "Expired_product",
  data() {
    return {
      img_value_stock: img_value_stock,
      img_value: img_value,
      selected_year_value: null,
      myChartValue: null,
      total_item_value: 0,
      year_arr: [],
      graph_list: [],
      year: [
        {id: 1, name: 'ปี 2565'},
        {id: 2, name: 'ปี 2564'},
        {id: 3, name: 'ปี 2563'},
        {id: 4, name: 'ปี 2562'},
        {id: 5, name: 'ปี 2561'},
      ],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      for (let i = 0; i < arr_year.length; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_year_value = this.year_arr[0].year_eng
      await this.dump_data_select()
    },
    async dump_data_select() {
      this.graph_list = []
      await HTTP.post('/dashboards/itemvaluewarehouse', {
        year: this.selected_year_value,
      }).then((res) => {
        if (res.data.success === true) {
          this.total_item_value = res.data.object.total_item_value
          res.data.object.total_drop_value.forEach((data) => {
            this.graph_list.push(parseFloat(data.total))
          })
          if (this.myChartValue !== null) {
            this.myChartValue.destroy()
          }
          this.chart_value()
        }
      })
    },
    chart_value() {
      let data = {
        labels: this.$store.state.monthThai,
        datasets: [
          {
            label: 'ยอดเงิน',
            data: this.graph_list,
            borderColor: '#8CC63E',
            backgroundColor: '#8CC63E',
            fill: false
          },
        ]
      }
      let config = {
        type: 'bar',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
        }
      }
      const ctx = document.getElementById('myChartValue').getContext('2d');
      this.myChartValue = new Chart(ctx, config)
    },
  },
  mounted() {
    this.year_function()
  }
}
</script>

<style scoped>
.grid_line_first {
  display: grid;
  grid-template-columns: 100%;
}
.grid_warehouse {
  display: grid;
  grid-template-columns: 20% 80%;
}
.grid_warehouse_header {
  display: grid;
  grid-template-columns: 100%;
}
.grid_select {
  display: grid;
  grid-template-columns: 80% 20%;
}
.grid_header_sell {
  display: grid;
  grid-template-columns: 10% 90%;
}
.font_warehouse {
  color: #86bc3a;
  font-size: 28px;
}
@media only screen and (max-width: 1180px) {
  .grid_header_sell {
    display: grid;
    grid-template-columns: 22% 78%;
  }
  .grid_warehouse {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_select {
    display: grid;
    grid-template-columns: 70% 30%;
  }
  .font_warehouse {
    color: #86bc3a;
    font-size: 24px;
  }
}
@media only screen and (max-width: 500px) {
  .grid_select {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_header_sell {
    display: grid;
    grid-template-columns: 30% 70%;
  }
  .font_warehouse {
    color: #86bc3a;
    font-size: 24px;
  }
}
</style>
